import jsPDF from "jspdf";
import "jspdf-autotable";
// Date Fns is used to format the dates we receive
// from our API call
import { format } from "date-fns";

// define a generatePDF function that accepts a tickets argument
const generatePDF = customerReport => {
  // initialize jsPDF
//   const doc = new jsPDF();
const doc = new jsPDF('l', 'mm', 'a4');
const d =      format(new Date(), "yyyy-MM-dd")
;
  // define the columns we want and their titles
  const tableColumn = ["Name","Email", "Phone Number","Dog Count","License Count","Created Date" ];
  // define an empty array of rows
  const tableRows = [];

  // for each report pass all its data into an array
  customerReport.forEach(report => {
    const paymentData = [
      report.userName,
      report.email,
      report.phoneNumber,
      report.dogCount,
      report.licenseCount,
     report.createdDate
      // called date-fns to format the date on the report
    ];
   
    tableRows.push(paymentData);
  });

  // startY is basically margin-top
  doc.autoTable(tableColumn, tableRows, { startY: 20 });
  // we use a date string to generate our filename.
  // report title. and margin-top + margin-left
  doc.text("Customer payment"+d, 14, 15);
  // we define the name of our PDF file.
  doc.save(`customer_report_${d}.pdf`);
};

export default generatePDF;